export enum PRILPriority {
  ASAP = "ASAP",
  HIGHEST = "HIGHEST",
  REGULAR = "REGULAR"
}

export enum PRILSource {
  E_LETTER = "E_LETTER",
  PAPER = "PAPER",
  CUSTOMER = "CUSTOMER"
}

export enum PRILStatus {
  NEW = "NEW",
  ASSIGNED = "ASSIGNED",
  ATTACHED = "ATTACHED",
  WORKING_ON_IT = "WORKING_ON_IT",
  DONE = "DONE",
  PAID = "PAID",
  STUCK = "STUCK",
  PENDING = "PENDING",
  HARD = "HARD",
  SENT = "SENT",
  SUSPENDED = "SUSPENDED",
  NO_SERVICE = "NO_SERVICE"
}
